import {
  Alert,
  Box,
  Paper,
  Stack,
  TableContainer,
  Typography,
} from "@mui/material";
import { useCraneDriver } from "./CraneDriverProvider";

import { useTenantTranslation } from "hooks/formatters";
import { CraneTable } from "./craneTable/CraneTable";

export const CraneDriver = () => {
  const { t } = useTenantTranslation();
  const { displayName, assignedLoads, hasSubmissionError } = useCraneDriver();

  const submissionError = hasSubmissionError ? (
    <Alert severity="error">{t("errorSavingChanges")}</Alert>
  ) : null;

  if (!assignedLoads.length) {
    return (
      <Stack gap={2} alignItems="center" padding={5}>
        {submissionError}
        <Typography variant="h1">{displayName}</Typography>
        <Typography variant="h1">{t("noBasket")}</Typography>
        <Typography variant="h6">{t("noBasketAssignedToCrane")}</Typography>
        <Typography variant="h6">
          {t("pleaseContactShiftSupervisor")}
        </Typography>
      </Stack>
    );
  }

  return (
    <Box sx={{ padding: 2 }}>
      {submissionError}
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          maxHeight: "100%",
          overflowY: "auto",
          border: 1,
          borderColor: "grey.300",
        }}
      >
        <CraneTable />
      </TableContainer>
    </Box>
  );
};
